import { formatDate } from "../format"
import { TextCell } from "./text-cell"

type Props = {
  value: string | null | undefined
  align?: "left" | "right" | "center"
}

export function DateCell({ value, align = "left" }: Props) {
  return <TextCell value={formatDate(value)} align={align} />
}
